<template src="./RiskWeeklyTable.html"></template>

<script>
import _ from "lodash";
import { formatDecimal, formatYearsOf, withYears } from "@/modules/DataAnalysis/Risk/riskFormat";

export default {
  name: "RiskWeeklyTable",
  props: {
    bars: { type: Array, default: () => [] },
    presentation: { type: Object, default: null },
  },
  computed: {
    detailColumns() {
      return (this.presentation && this.presentation.detailColumns) || [];
    },
    // Heat index only (riskPresentation.js#showEventYears): name the years in parentheses.
    showEventYears() {
      return !!(this.presentation && this.presentation.showEventYears);
    },
  },
  methods: {
    yearsOf(bar) {
      const text = formatYearsOf(bar.yearsWithEvent, bar.yearsTotal);
      // Every year had the event: "7 of 7" already says which, so skip the list.
      const allYears = bar.yearsTotal > 0 && bar.yearsWithEvent === bar.yearsTotal;
      return this.showEventYears && !allYears ? withYears(text, _.get(bar.raw, "event_years")) : text;
    },
    pctText(bar) {
      if (bar.pctDisplay == null) return "—";
      return `${bar.prefix}${bar.pctDisplay}%`;
    },
    columnValue(bar, column) {
      const text = formatDecimal(_.get(bar.raw, column.key), column.decimals);
      return this.showEventYears && column.yearKey ? withYears(text, _.get(bar.raw, column.yearKey)) : text;
    },
  },
};
</script>

<style lang="scss" src="./RiskWeeklyTable.scss"></style>
